export const types = [
    {
        "type": "0",
        "zh-CN": "建议优化",
        "en": "Suggest Optimization",
        "zh-TW": "建議優化",
        "ja": "最適化の提案",
        "ko": "최적화 제안",
        "fr": "Suggérer des Optimisations",
        "de": "Vorschlag zur Optimierung",                       //德语
        "pt": "Sugerir Otimização",                       //葡萄牙语
        "es": "Sugerir Optimización",   //西班牙语
        "it": "Suggerire Ottimizzazione",                       //意大利语
        "ru": "Предложить Оптимизацию",                       //俄语
        "id": "Sarankan Optimalisasi",                       //印尼语
        "th": "เสนอแนวทางการปรับปรุง",    //泰语
        "vi": "Đề xuất tối ưu hóa",     //越南语
        "tr": "Optimizasyon Önerisi",                       //土耳其语
    },
    {
        "type": "1",
        "zh-CN": "异常BUG",
        "en": "Anomalous Bug",
        "zh-TW": "異常BUG",
        "ja": "異常なバグ",
        "ko": "비정상적인 버그",
        "fr": "Bug Anormal",
        "de": "Anomaler Fehler",                       //德语
        "pt": "Bug Anômalo",                       //葡萄牙语
        "es": "Error Anómalo",   //西班牙语
        "it": "Bug Anomalo",                       //意大利语
        "ru": "Аномальная Ошибка",                       //俄语
        "id": "Bug Anomali",                       //印尼语
        "th": "ข้อบกพร่องที่ผิดปกติ",    //泰语
        "vi": "Lỗi bất thường",     //越南语
        "tr": "Anormal Hata",                       //土耳其语
    },
    {
        "type": "2",
        "zh-CN": "支付问题",
        "en": "Payment Issue",
        "zh-TW": "支付問題",
        "ja": "支払いの問題",
        "ko": "결제 문제",
        "fr": "Problème de Paiement",
        "de": "Zahlungsproblem",                       //德语
        "pt": "Problema de Pagamento",                       //葡萄牙语
        "es": "Problema de Pago",   //西班牙语
        "it": "Problema di Pagamento",                       //意大利语
        "ru": "Проблема с Оплатой",                       //俄语
        "id": "Masalah Pembayaran",                       //印尼语
        "th": "ปัญหาการชำระเงิน",    //泰语
        "vi": "Vấn đề thanh toán",     //越南语
        "tr": "Ödeme Sorunu",                       //土耳其语
    },
    {
        "type": "3",
        "zh-CN": "存档相关",
        "en": "Save Data Related",
        "zh-TW": "存檔相關",
        "ja": "データ保存に関する問題",
        "ko": "저장 데이터 관련",
        "fr": "Relatif aux Données Enregistrées",
        "de": "Speicherbezogene Daten",                       //德语
        "pt": "Relacionado a Dados Salvos",                       //葡萄牙语
        "es": "Relacionado con los Datos Guardados",   //西班牙语
        "it": "Relativo ai Dati Salvati",                       //意大利语
        "ru": "Связано с Данными Сохранения",                       //俄语
        "id": "Terkait Data Simpan",                       //印尼语
        "th": "เกี่ยวกับข้อมูลการบันทึก",    //泰语
        "vi": "Liên quan đến lưu trữ",     //越南语
        "tr": "Kayıt Verileri ile İlgili",                       //土耳其语
    },
    {
        "type": "4",
        "zh-CN": "举报反馈",
        "en": "Report Feedback",
        "zh-TW": "舉報反饋",
        "ja": "反応を報告する",
        "ko": "피드백 신고",
        "fr": "Signaler des Commentaires",
        "de": "Rückmeldung Melden",                       //德语
        "pt": "Reportar Feedback",                       //葡萄牙语
        "es": "Informar Retroalimentación",   //西班牙语
        "it": "Segnalare Feedback",                       //意大利语
        "ru": "Отчет Отзывы",                       //俄语
        "id": "Laporkan Umpan Balik",                       //印尼语
        "th": "รายงานข้อเสนอแนะ",    //泰语
        "vi": "Báo cáo phản hồi",     //越南语
        "tr": "Geri Bildirim Raporu",                       //土耳其语
    },
    {
        "type": "5",
        "zh-CN": "其他",
        "en": "Others",
        "zh-TW": "其他",
        "ja": "その他",
        "ko": "기타",
        "fr": "Autres",
        "de": "Andere",                       //德语
        "pt": "Outros",                       //葡萄牙语
        "es": "Otros",   //西班牙语
        "it": "Altri",                       //意大利语
        "ru": "Другие",                       //俄语
        "id": "Lainnya",                       //印尼语
        "th": "อื่นๆ",    //泰语
        "vi": "Khác",     //越南语
        "tr": "Diğerleri",                       //土耳其语
    },
    {
        "type": "6",
        "zh-CN": "请下拉选择问题分类",
        "en": "Please select a category from the dropdown",
        "zh-TW": "請下拉選擇問題分類",
        "ja": "ドロップダウンからカテゴリを選択してください",
        "ko": "드롭다운에서 문제 분류를 선택하세요",
        "fr": "Veuillez sélectionner une catégorie dans la liste déroulante",
        "de": "Bitte wählen Sie eine Kategorie aus dem Dropdown-Menü",
        "pt": "Por favor, selecione uma categoria no menu suspenso",
        "es": "Por favor, seleccione una categoría del menú desplegable",
        "it": "Si prega di selezionare una categoria dal menu a tendina",
        "ru": "Пожалуйста, выберите категорию из выпадающего списка",
        "id": "Silakan pilih kategori dari menu dropdown",
        "th": "กรุณาเลือกหมวดหมู่จากเมนูแบบเลื่อนลง",
        "vi": "Vui lòng chọn một danh mục từ menu thả xuống",
        "tr": "Lütfen açılır menüden bir kategori seçin"
    }
]


// WEBPACK FOOTER //
// ./src/tool/types.js